import _styled from "@emotion/styled/base";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { css } from '@emotion/react';
import { colors, getResetByTag, rem, utilityStyles } from './../../../../styles';
import prepareResponsiveProps from '../../functions/responsive-grid-props';
import mediaQueries from '../../functions/generate-media-queries';
var max_columns = 12;
var defaultStyles = /*#__PURE__*/css("box-sizing:border-box;padding:", rem(8), ";width:100%;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var borderStyles = function borderStyles(_ref) {
  var borderBottom = _ref.borderBottom,
    borderLeft = _ref.borderLeft,
    borderRight = _ref.borderRight,
    borderTop = _ref.borderTop;
  return /*#__PURE__*/css(borderBottom && /*#__PURE__*/css("border-bottom:solid ", rem(1), " ", colors.gray_300, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderStyles;")), " ", borderLeft && /*#__PURE__*/css("border-left:solid ", rem(1), " ", colors.gray_300, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderStyles;")), " ", borderRight && /*#__PURE__*/css("border-right:solid ", rem(1), " ", colors.gray_300, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderStyles;")), " ", borderTop && /*#__PURE__*/css("border-top:solid ", rem(1), " ", colors.gray_300, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:borderStyles;"));
};
var columnWidthStyles = function columnWidthStyles(_ref2) {
  var cols = _ref2.cols;
  var responsiveCols = prepareResponsiveProps(max_columns, cols);
  var styles = "";
  for (var _i = 0, _Object$entries = Object.entries(mediaQueries); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (isNaN(responsiveCols[key])) {
      continue;
    }
    var pct = responsiveCols[key] / max_columns * 100;
    styles += "\n      ".concat(value, " {\n        flex-basis: ").concat(pct, "%;\n        max-width: ").concat(pct, "%;\n      }\n    ");
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:columnWidthStyles;"));
};
var isGrayStyles = function isGrayStyles(_ref3) {
  var isGray = _ref3.isGray;
  if (isGray) {
    return /*#__PURE__*/css("background-color:", colors.gray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:isGrayStyles;"));
  }
};
var offsetStyles = function offsetStyles(_ref4) {
  var offset = _ref4.offset;
  var responsiveOffsets = prepareResponsiveProps(0, offset);
  var styles = "";
  for (var _i2 = 0, _Object$entries2 = Object.entries(mediaQueries); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    if (isNaN(responsiveOffsets[key])) {
      continue;
    }
    var pct = 100 / max_columns * responsiveOffsets[key];
    styles += "\n      ".concat(value, " {\n        margin-left: ").concat(pct, "%;\n      }\n    ");
  }
  return /*#__PURE__*/css(styles, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:offsetStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledGridColumn = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eh19fvf0"
} : {
  target: "eh19fvf0",
  label: "StyledGridColumn"
})(resetStyles, defaultStyles, borderStyles, columnWidthStyles, isGrayStyles, offsetStyles, utilityStyles);
export default StyledGridColumn;